import { Pipe, PipeTransform, NgModule } from '@angular/core';

@Pipe({name: 'transferSnsTime'})
export class TransferSnsTime implements PipeTransform {
    transform(time: number): string {
        let rtn: string;
        const now: any = new Date();
        const today: any = new Date(time);

        const dateGap = now.getTime() - today.getTime();

        if (dateGap === 0) {
             return '방금 전' ;
        }

        const timeGap = new Date(0, 0, 0, 0, 0, 0, now - today);

        const diffDay  = Math.floor(dateGap / (1000 * 60 * 60 * 24)); // 일수
        const diffHour = timeGap.getHours();         // 시간
        const diffMin  = timeGap.getMinutes();        // 분
        const diffSec  = timeGap.getSeconds();        // 초

        if (diffDay < 0) { rtn = '방금 전'; }
        if (diffDay > 0) { rtn = diffDay + '일 전'; }
        if (diffHour > 0) { rtn = diffHour + '시간 전'; }
        if (diffMin > 0) { rtn = diffMin + '분 ' + diffSec + '초 전'; }
        if (diffSec >= 0) { rtn = '방금전'; }
        // if (diffSec > 0) return diffSec + '초 전';
        // if (diffSec === 0) return '방금 전';
        return rtn;
    }
}

@NgModule({
    declarations: [ TransferSnsTime ],
    exports: [ TransferSnsTime ],
})
export class TransferSnsTimePipeModule { }
